'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _components = require('components');

var _close_black = require('assets/img/common/close_black.png');

var _close_black2 = _interopRequireDefault(_close_black);

var _success_send = require('assets/img/common/success_send.png');

var _success_send2 = _interopRequireDefault(_success_send);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    loadingSending: state.user.loadingSending,
    sendFeedbackSuccess: state.user.sendFeedbackSuccess
  };
}, (0, _extends3.default)({}, userActions, {
  pushState: _reactRouterRedux.push
}, authActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FeedbackMobile, _Component);

  function FeedbackMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FeedbackMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeedbackMobile.__proto__ || (0, _getPrototypeOf2.default)(FeedbackMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      images: [],
      errorMsg: '',
      modalVisible: false,
      emailValidate: true,
      feedback: '',
      email: _this.props.user ? _this.props.user.email : null
    }, _this.handleChangeEmail = function (event) {
      var emailValidate = false;
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(event.target.value) || event.target.value === '') {
        emailValidate = true;
      }
      _this.setState({ email: event.target.value, emailValidate: emailValidate });
    }, _this.handleChangeFeedback = function (event) {
      _this.setState({ feedback: event.target.value });
    }, _this.onCloseSuccessModal = function () {
      _this.setState({ modalVisible: false });
      _this.props.pushState('/tai-khoan');
    }, _this.onSending = function () {
      var email = _this.state.email;
      var feedback = _this.state.feedback;
      var img = _this.state.images;
      var data = {
        email: email,
        content: feedback,
        extra: window.navigator.userAgent
      };
      if (email.length > 0 && feedback.length > 0 && _this.state.emailValidate) {
        _this.props.sendFeedback(data, img);
        _this.setState({ images: '', feedback: '' });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FeedbackMobile, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.sendFeedbackSuccess !== nextProps.sendFeedbackSuccess && nextProps.sendFeedbackSuccess === true) {
        this.setState({ modalVisible: true });
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(acceptedFiles) {
      var totalSize = 0;
      acceptedFiles.map(function (file) {
        return totalSize += file.size;
      });
      if (totalSize > 10000000) {
        this.setState({
          errorMsg: 'Dung lượng hình ảnh quá lớn, vui lòng chọn hình ảnh có tổng dung lượng nhỏ hơn 10 MB'
        });
        return;
      }
      this.setState({ images: acceptedFiles, errorMsg: '' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          emailValidate = _state.emailValidate,
          email = _state.email,
          feedback = _state.feedback,
          images = _state.images,
          errorMsg = _state.errorMsg;

      var styles = require('./FeedbackMobile.scss');
      var loadingSending = this.props.loadingSending;

      return _react2.default.createElement(
        'div',
        { className: styles.box },
        loadingSending && _react2.default.createElement(_components.Loading, null),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          { show: this.state.modalVisible, onHide: this.onCloseSuccessModal },
          _react2.default.createElement(
            'div',
            {
              style: {
                flex: 1,
                flexDirection: 'row',
                backgroundColor: 'rgba(61,55,54,.4)'
              }
            },
            _react2.default.createElement(
              'div',
              {
                style: {
                  justifyContent: 'center',
                  alignItems: 'center',
                  flex: 1
                },
                onClick: this.onCloseSuccessModal
              },
              _react2.default.createElement(
                'div',
                { className: styles.modal },
                _react2.default.createElement(
                  'div',
                  { className: styles.contentModal },
                  _react2.default.createElement(
                    'div',
                    { className: styles.smallModalView1 },
                    _react2.default.createElement(
                      'div',
                      {
                        onClick: function onClick() {
                          _this2.onCloseSuccessModal();
                        }
                      },
                      _react2.default.createElement('img', {
                        src: _close_black2.default,
                        resizeMode: 'contain',
                        className: styles.closeIcon
                      })
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.smallModalView2 },
                    _react2.default.createElement('img', {
                      src: _success_send2.default,
                      resizeMode: 'contain',
                      className: styles.successIcon
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.smallModalView3 },
                    _react2.default.createElement(
                      'div',
                      { className: styles.textModal },
                      'Lookme \u0111\xE3 nh\u1EADn \u0111\u01B0\u1EE3c ph\u1EA3n h\u1ED3i. R\u1EA5t c\u1EA3m \u01A1n b\u1EA1n \u0111\xE3 \u0111\xF3ng g\xF3p \xFD ki\u1EBFn!'
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.firstView },
          _react2.default.createElement(
            'div',
            { className: styles.emailText },
            'Email'
          ),
          _react2.default.createElement('textarea', {
            type: 'text',
            placeholder: 'Nhap email cua ban',
            className: styles.emailInput,
            value: this.state.email,
            onChange: this.handleChangeEmail
          }),
          emailValidate === false && _react2.default.createElement(
            'div',
            { className: styles.help },
            'Email kh\xF4ng h\u1EE3p l\u1EC7!'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.secondView },
          _react2.default.createElement(
            'div',
            { className: styles.feedbackText },
            'G\xF3p \xDD'
          ),
          _react2.default.createElement('textarea', {
            type: 'text',
            placeholder: 'B\u1EA1n mu\u1ED1n g\xF3p \xFD g\xEC?...',
            className: styles.feedbackInput,
            value: this.state.feedback,
            onChange: this.handleChangeFeedback
          }),
          _react2.default.createElement(
            'div',
            { className: styles.rrow + ' ' + styles.mT20 },
            _react2.default.createElement(
              'div',
              { className: styles.textAddImage },
              'Th\xEAm h\xECnh \u1EA3nh (Kh\xF4ng b\u1EAFt bu\u1ED9c)'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.rimage },
              _react2.default.createElement(
                'div',
                { className: styles.listImages },
                _react2.default.createElement(
                  _reactDropzone2.default,
                  {
                    className: styles.dropZone + ' dropzone',
                    onDrop: this.onDrop.bind(this),
                    multiple: true,
                    accept: 'image/*'
                  },
                  _react2.default.createElement('div', { className: styles.addImageVideo })
                ),
                images.length > 0 && _react2.default.createElement(
                  'div',
                  null,
                  images.map(function (image, index) {
                    return image.type.split('/')[0] === 'video' ? _react2.default.createElement(
                      'div',
                      { key: image.lastModified },
                      _react2.default.createElement('video', {
                        src: image.preview,
                        key: image.lastModified + '_' + index,
                        width: '100%',
                        height: '250px',
                        controls: true
                      })
                    ) : _react2.default.createElement('img', {
                      src: image.preview,
                      key: image.lastModified + '_' + index,
                      className: styles.thumbImage
                    });
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.errorMessage },
                  errorMsg
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.sendButton + (email.length === 0 || feedback.length === 0 || !emailValidate ? ' ' + styles.inactive : ''),
                    onClick: this.onSending
                  },
                  'G\u1EEDi'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return FeedbackMobile;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  sendFeedbackSuccess: _react.PropTypes.bool,
  loadingSending: _react.PropTypes.bool,
  sendFeedback: _react.PropTypes.func,
  toggleModal: _react.PropTypes.func,
  pushState: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = FeedbackMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Feedback/FeedbackMobile.js
// module id = 1596
// module chunks = 0